import React from 'react'

const SkeletonClassList = ({ count = 5 }) => {
    return (
        <div>
            {Array.from({ length: count }).map((_, idx) => (
                <div className="management-frame" style={{ marginTop: 20, paddingTop: 40, paddingBottom: 40 }} key={idx}>
                    <div className="classes-lists-container ">
                        <div key={idx} className="flex flex-row items-center justify-end gap-[30px] ">
                            <div>
                                <div className="flex items-center gap-2">
                                    <div className="h-[20px] w-[20px] rounded-full bg-lightBG animate-pulse" />
                                    <div className="h-5 w-[110px] rounded bg-lightBG animate-pulse" />
                                </div>
                                <div className="flex items-center gap-2 mt-1">
                                    <div className="h-[20px] w-[20px] rounded-full bg-lightBG animate-pulse" />
                                    <div className="h-5 w-[130px] rounded bg-lightBG animate-pulse" />
                                </div>
                            </div>

                            <div className="h-[106px] w-[106px] rounded-full bg-lightBG animate-pulse" />
                        </div>

                        <div className="flex flex-row items-center gap-4 ml-10 flex-1">
                            <div className="flex flex-col gap-1  ">
                                <div className="h-5 w-10 bg-lightBG rounded animate-pulse" />
                                <div className="h-[38px] w-10 bg-lightBG rounded animate-pulse" />
                            </div>
                            <div className="flex flex-col gap-1  ">
                                <div className="h-5 w-10 bg-lightBG rounded animate-pulse" />
                                <div className="h-[38px] w-10 bg-lightBG rounded animate-pulse" />
                            </div>
                            <div className="flex flex-col items-center gap-1  ">
                                <div className="h-5 w-[120px] bg-lightBG rounded animate-pulse" />
                                <div className="h-[38px] w-14 bg-lightBG rounded animate-pulse" />
                            </div>
                        </div>

                        <div className="flex gap-2">
                            <div className="w-[56px] h-[56px] rounded-full bg-lightBG animate-pulse" />
                            <div className="w-[56px] h-[56px] rounded-full bg-lightBG animate-pulse" />
                            <div className="w-[56px] h-[56px] rounded-full bg-lightBG animate-pulse" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default SkeletonClassList
